module.exports = __webpack_public_path__ + "static/img/indexPrint.b4c7e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexPrint.png
// module id = cZVk
// module chunks = 2